import { Button, Modal } from 'react-bootstrap'

export enum RecordType {
  Project = 'Project',
  Portal = 'Portal',
  Attachment = 'Attachment',
}

interface Props {
  show: boolean,
  onClose: () => void,
  onCancel: () => void,
  onDelete?: () => void,
  isDeleting: boolean,
  recordType: RecordType,
  title?: string,
}

export default function({
  show,
  onClose,
  onCancel,
  onDelete,
  isDeleting,
  recordType,
  title = 'Confirm Delete',
}: Props) {

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {`Are you sure you want to delete this ${recordType}?`}
        <br />
        This action is permanent and cannot be undone!
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="outline-primary" onClick={onCancel}
          disabled={isDeleting}
        >
          Cancel
        </Button>
        <Button
          variant="danger"
          onClick={onDelete} disabled={isDeleting}
        >
          {isDeleting ? 'Deleting...' : 'Delete'}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
